
export enum UserRole {
  USER = 'USER',
  AGENCY = 'AGENCY',
  ADMIN = 'ADMIN'
}

export enum AssetType {
  LOGO_LIGHT = 'LOGO_LIGHT',
  LOGO_DARK = 'LOGO_DARK',
  ICON_LIGHT = 'ICON_LIGHT',
  ICON_DARK = 'ICON_DARK',
  GENERATED_MOCKUP = 'GENERATED_MOCKUP',
  TEXT = 'TEXT'
}

export enum GridSize {
  SQUARE_SM = '1x1', // 1080x1080 small
  SQUARE_MD = '2x2', // 1080x1080 med
  SQUARE_LG = '4x4', // 1080x1080 large
  LANDSCAPE_SM = '2x1', // 1920x1080
  LANDSCAPE_MD = '4x2',
  PORTRAIT_SM = '1x2', // 1080x1920
  PORTRAIT_MD = '2x4'
}

export interface TextData {
  title: string;
  body: string;
  chevrons: {
    top: boolean;
    right: boolean;
    bottom: boolean;
    left: boolean;
  };
  alignment: 'left' | 'center' | 'right';
}

export interface BrandAsset {
  id: string;
  type: AssetType;
  url: string; // Base64 or URL (Empty for Text)
  gridSize: GridSize;
  isPasswordProtected: boolean;
  order: number;
  prompt?: string; // If generated
  backgroundColor?: string; // Hex code for container background
  deletedAt?: string | null; // ISO Date for trash logic
  padding?: number; // Padding in px
  textData?: TextData; // For AssetType.TEXT
}

export interface BrandColor {
  id: string;
  hex: string;
  cmyk?: string; // C:0 M:0 Y:0 K:100
  name: string; // Description (e.g. "Primary Brand Color")
  visible: boolean;
}

export interface UserProfile {
  id: string;
  companyName: string;
  email?: string;
  password?: string;
  role: UserRole;
  managedBy?: string; // Agency ID
  assets: BrandAsset[];
  colors: BrandColor[]; // Updated to array
  pricingPlan: 'wholesale' | 'retail_basic' | 'retail_ai';
  publicPassword?: string;
  
  // Public Page Settings
  publicUrlSlug?: string;
  publicTitle?: string;
  showPublicTitle?: boolean;
  hiddenColorKeys?: string[]; // Deprecated but kept for type compatibility during migration if needed
  fontFamily?: string; // Google Font Name
  
  // App State
  onboarding?: {
    completed: string[];
    skipped: string[];
  };
}

export interface AgencyClient extends UserProfile {
  // Client specific fields if needed in future
}

// Data coming from api.joisst.com
export interface JoisstUser {
  userId: string;
  email: string;
  isAdmin: boolean;
  currency: string;
  referralCode?: string;
  referralCount?: number;
  planId?: string; // 'price_free', 'price_pro', etc.
  hearts?: number;
}
